// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tekla-common-footer h2,
#trimble-common-footer h2 {
    font-family: Open Sans;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.0025em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

#tekla-common-footer h2 {
    font-size: 18px;
    margin-bottom: 0.25em;
}

#trimble-common-footer h2 {
    font-size: 16px;
    margin-bottom: 1.25rem;
    margin-top: 0;
}

#tekla-common-footer h2.all-caps,
#trimble-common-footer h2.all-caps {
    text-transform: uppercase;
}

#tekla-common-footer p,
#tekla-common-footer a,
#trimble-common-footer p,
#trimble-common-footer a {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.0025em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
}

#tekla-common-footer p.mini,
#trimble-common-footer p.mini {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.06px;
}

#trimble-common-footer p.mini {
    background-color: #252A2E;
}

#tekla-common-footer a,
#tekla-common-footer button,
#trimble-common-footer a,
#trimble-common-footer button {
    color: #FFF;
    text-decoration: underline;
    text-underline-offset: 4px;
}

#tekla-common-footer a:hover,
#tekla-common-footer button.cookie-preferences-link:hover,
#trimble-common-footer a:hover,
#trimble-common-footer button.cookie-preferences-link:hover {
    text-decoration: underline #FBAD26 !important;
}

#tekla-common-footer .footer-base,
#trimble-common-footer .footer-base {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

#tekla-common-footer .footer-top,
#trimble-common-footer .footer-base {
    background-color: #252A2E;
}

#tekla-common-footer .footer-bottom {
    background-color: #353A40;
}

#trimble-common-footer .footer-top {
    padding-bottom: 2rem;
}

#trimble-common-footer .footer-top * {
    font-size: 16px;
}

#trimble-common-footer .footer-top p a {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.035px;
}

#tekla-common-footer>.footer-base .footer-content,
#trimble-common-footer>.footer-base .footer-content {
    max-width: 1340px;
    flex: auto;
    margin-right: auto;
    margin-left: auto;
    display: flex;
    padding: 3.75rem 2rem;
}

#trimble-common-footer>.footer-base .footer-content {
    flex-direction: column;
}

#tekla-common-footer>.footer-base .footer-content {
    flex-direction: row;
    justify-content: space-between;
    gap: 5%;
}

#tekla-common-footer .footer-top * {
    font-size: 16px;
}

#tekla-common-footer .footer-top p a {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.035px;
}

#tekla-common-footer .footer-content>div:first-child {
    width: 225px;
}

#tekla-common-footer .footer-content>div:nth-child(2) {
    width: 650px;
}

#tekla-common-footer .footer-content>div:last-child {
    width: 205px;
}

#tekla-common-footer .footer-top .contact-and-support,
#trimble-common-footer .footer-content .footer-top {
    display: flex;
    flex-direction: column;
}

#tekla-common-footer .footer-top .contact-and-support {
    align-items: flex-start;
    gap: 2rem;
}

#tekla-common-footer .footer-top .contact-and-support h1 {
    display: inline-flex;
}

#tekla-common-footer .footer-top .contact-and-support a {
    font-size: inherit;
    font-weight: inherit;
    text-decoration: none;
    display: inline;
}

#tekla-common-footer .footer-top .contact-and-support a svg {
    margin-bottom: -7px;
}

#tekla-common-footer .footer-top .contact-and-support a:hover svg path {
    fill: #FBAD26;
}

#tekla-common-footer .footer-top .links-with-titles {
    display: flex;
    flex-direction: row;
    gap: 30px;
}

#tekla-common-footer .footer-top .links-with-titles div {
    display: flex;
    flex-direction: column;
    width: 33%;
    gap: 24px;
}

#tekla-common-footer .footer-top .social-icons,
#trimble-common-footer .footer-top .social-icons {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 1rem;
}

#tekla-common-footer .footer-top .social-icons a:hover svg path,
#trimble-common-footer .footer-top .social-icons a:hover svg path {
    fill: #E0E1E9;
}

#tekla-common-footer .footer-bottom,
#trimble-common-footer .footer-bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
}

#trimble-common-footer .footer-bottom {
    padding-top: 2rem;
}

#trimble-common-footer .footer-content .footer-bottom>div:first-child {
    width: 225px;
    align-self: flex-start;
}

#trimble-common-footer .footer-content .footer-bottom>div:nth-child(2) {
    width: 650px;
}

#tekla-common-footer .footer-bottom .trimble-logo,
#trimble-common-footer .footer-bottom .trimble-logo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 19.8px;
}

#tekla-common-footer .footer-bottom .trimble-logo svg,
#trimble-common-footer .footer-bottom .trimble-logo svg {
    max-width: 150px;
}

#tekla-common-footer .footer-bottom .footer-description,
#trimble-common-footer .footer-bottom .footer-description {
    display: flex;
    flex-direction: column;
    align-self: stretch;
    gap: 1rem;
}

#tekla-common-footer .footer-bottom .footer-description p,
#trimble-common-footer .footer-bottom .footer-description p {
    max-width: 500px;
}

#tekla-common-footer .footer-description p,
#tekla-common-footer .footer-description a,
#trimble-common-footer .footer-description p,
#trimble-common-footer .footer-description a {
    font-size: 14px;
    line-height: 28px;
    letter-spacing: 0.035px;
}

#tekla-common-footer .footer-description a,
#trimble-common-footer .footer-description a {
    font-weight: 600;
}

#tekla-common-footer .links,
#trimble-common-footer .links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
}

#trimble-common-footer .links {
    gap: 1rem;
}

#tekla-common-footer .links a,
#trimble-common-footer .links a {
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.0025em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

#tekla-common-footer .links button.cookie-preferences-link,
#trimble-common-footer .links button.cookie-preferences-link {
    font-size: 12px;
    text-decoration: underline;
    font-weight: 600 !important;
}

#tekla-common-footer .w-20,
#trimble-common-footer .w-20 {
    width: 20% !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
}

#tekla-common-footer .footer-bottom .w-20,
#trimble-common-footer .footer-bottom .w-20 {
    gap: 12px;
}

#tekla-common-footer .w-60,
#trimble-common-footer .w-60 {
    width: 60% !important;
}

/* RESPONSIVITY */

@media only screen and (max-width: 1340px) {

    #tekla-common-footer .footer-base .footer-top .footer-content,
    #tekla-common-footer .footer-base .footer-bottom .footer-content,
    #trimble-common-footer>.footer-base .footer-content {
        max-width: 1160px;
    }
}

/* Large devices (laptops/desktops, up to 1200px) */
@media only screen and (max-width: 1200px) {

    #tekla-common-footer .footer-base .footer-content,
    #trimble-common-footer>.footer-base .footer-content {
        max-width: 100%;
        gap: 5%;
        padding: 3.75rem 2rem;
    }

    #tekla-common-footer .footer-content>div:first-child,
    #trimble-common-footer .footer-content .footer-bottom>div:first-child {
        width: 20%;
    }

    #tekla-common-footer .footer-content>div:nth-child(2),
    #trimble-common-footer .footer-content .footer-bottom>div:nth-child(2) {
        width: 50%;
    }

    #tekla-common-footer .footer-content>div:last-child,
    #trimble-common-footer .footer-content .footer-bottom>div:last-child {
        width: 20%;
    }
}

/* Small devices (portrait tablets and large phones, 768px and down) */
@media only screen and (max-width: 768px) {

    #tekla-common-footer .footer-content>div:last-child,
    #trimble-common-footer .footer-content .footer-bottom>div:last-child {
        width: 15%;
    }

    #tekla-common-footer .footer-top .footer-content>.social-icons {
        justify-content: center;
        width: 10%;
    }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {

    #tekla-common-footer .footer-base .footer-content,
    #trimble-common-footer .footer-base .footer-bottom {
        flex-direction: column;
        gap: 40px;
        flex-wrap: wrap;
    }

    #tekla-common-footer .footer-base .footer-content {
        padding: 40px 20px;
    }

    #trimble-common-footer .footer-base .footer-bottom {
        padding: 3rem 0 0 0;
    }

    #tekla-common-footer .footer-base .footer-content>div,
    #trimble-common-footer .footer-base .footer-content .footer-bottom>div {
        width: 100% !important;
    }

    #tekla-common-footer .footer-top .links-with-titles {
        gap: 40px;
        flex-wrap: wrap;
    }

    #tekla-common-footer .footer-top .footer-content>.social-icons {
        justify-content: flex-start;
    }

    #tekla-common-footer .footer-top .links-with-titles div {
        width: 40%;
    }

    #tekla-common-footer .footer-bottom .links {
        gap: 32px;
    }

    #trimble-common-footer .footer-bottom .links {
        gap: 1.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;;IAEI,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,aAAa;AACjB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;;IAII,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,SAAS;AACb;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;IAII,WAAW;IACX,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;;;;IAII,6CAA6C;AACjD;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;IAEI,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,OAAO;AACX;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,SAAS;AACb;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;;;IAII,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;;IAEI,eAAe;IACf,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;;IAEI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,iBAAiB;;AAEjB;;IAEI;;;QAGI,iBAAiB;IACrB;AACJ;;AAEA,mDAAmD;AACnD;;IAEI;;QAEI,eAAe;QACf,OAAO;QACP,qBAAqB;IACzB;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,UAAU;IACd;AACJ;;AAEA,sEAAsE;AACtE;;IAEI;;QAEI,UAAU;IACd;;IAEA;QACI,uBAAuB;QACvB,UAAU;IACd;AACJ;;AAEA,iDAAiD;AACjD;;IAEI;;QAEI,sBAAsB;QACtB,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["#tekla-common-footer h2,\n#trimble-common-footer h2 {\n    font-family: Open Sans;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.0025em;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n#tekla-common-footer h2 {\n    font-size: 18px;\n    margin-bottom: 0.25em;\n}\n\n#trimble-common-footer h2 {\n    font-size: 16px;\n    margin-bottom: 1.25rem;\n    margin-top: 0;\n}\n\n#tekla-common-footer h2.all-caps,\n#trimble-common-footer h2.all-caps {\n    text-transform: uppercase;\n}\n\n#tekla-common-footer p,\n#tekla-common-footer a,\n#trimble-common-footer p,\n#trimble-common-footer a {\n    font-family: Open Sans;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 18px;\n    letter-spacing: 0.0025em;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    margin: 0;\n}\n\n#tekla-common-footer p.mini,\n#trimble-common-footer p.mini {\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0.06px;\n}\n\n#trimble-common-footer p.mini {\n    background-color: #252A2E;\n}\n\n#tekla-common-footer a,\n#tekla-common-footer button,\n#trimble-common-footer a,\n#trimble-common-footer button {\n    color: #FFF;\n    text-decoration: underline;\n    text-underline-offset: 4px;\n}\n\n#tekla-common-footer a:hover,\n#tekla-common-footer button.cookie-preferences-link:hover,\n#trimble-common-footer a:hover,\n#trimble-common-footer button.cookie-preferences-link:hover {\n    text-decoration: underline #FBAD26 !important;\n}\n\n#tekla-common-footer .footer-base,\n#trimble-common-footer .footer-base {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n#tekla-common-footer .footer-top,\n#trimble-common-footer .footer-base {\n    background-color: #252A2E;\n}\n\n#tekla-common-footer .footer-bottom {\n    background-color: #353A40;\n}\n\n#trimble-common-footer .footer-top {\n    padding-bottom: 2rem;\n}\n\n#trimble-common-footer .footer-top * {\n    font-size: 16px;\n}\n\n#trimble-common-footer .footer-top p a {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.035px;\n}\n\n#tekla-common-footer>.footer-base .footer-content,\n#trimble-common-footer>.footer-base .footer-content {\n    max-width: 1340px;\n    flex: auto;\n    margin-right: auto;\n    margin-left: auto;\n    display: flex;\n    padding: 3.75rem 2rem;\n}\n\n#trimble-common-footer>.footer-base .footer-content {\n    flex-direction: column;\n}\n\n#tekla-common-footer>.footer-base .footer-content {\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 5%;\n}\n\n#tekla-common-footer .footer-top * {\n    font-size: 16px;\n}\n\n#tekla-common-footer .footer-top p a {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.035px;\n}\n\n#tekla-common-footer .footer-content>div:first-child {\n    width: 225px;\n}\n\n#tekla-common-footer .footer-content>div:nth-child(2) {\n    width: 650px;\n}\n\n#tekla-common-footer .footer-content>div:last-child {\n    width: 205px;\n}\n\n#tekla-common-footer .footer-top .contact-and-support,\n#trimble-common-footer .footer-content .footer-top {\n    display: flex;\n    flex-direction: column;\n}\n\n#tekla-common-footer .footer-top .contact-and-support {\n    align-items: flex-start;\n    gap: 2rem;\n}\n\n#tekla-common-footer .footer-top .contact-and-support h1 {\n    display: inline-flex;\n}\n\n#tekla-common-footer .footer-top .contact-and-support a {\n    font-size: inherit;\n    font-weight: inherit;\n    text-decoration: none;\n    display: inline;\n}\n\n#tekla-common-footer .footer-top .contact-and-support a svg {\n    margin-bottom: -7px;\n}\n\n#tekla-common-footer .footer-top .contact-and-support a:hover svg path {\n    fill: #FBAD26;\n}\n\n#tekla-common-footer .footer-top .links-with-titles {\n    display: flex;\n    flex-direction: row;\n    gap: 30px;\n}\n\n#tekla-common-footer .footer-top .links-with-titles div {\n    display: flex;\n    flex-direction: column;\n    width: 33%;\n    gap: 24px;\n}\n\n#tekla-common-footer .footer-top .social-icons,\n#trimble-common-footer .footer-top .social-icons {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-content: flex-start;\n    gap: 1rem;\n}\n\n#tekla-common-footer .footer-top .social-icons a:hover svg path,\n#trimble-common-footer .footer-top .social-icons a:hover svg path {\n    fill: #E0E1E9;\n}\n\n#tekla-common-footer .footer-bottom,\n#trimble-common-footer .footer-bottom {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 2rem;\n}\n\n#trimble-common-footer .footer-bottom {\n    padding-top: 2rem;\n}\n\n#trimble-common-footer .footer-content .footer-bottom>div:first-child {\n    width: 225px;\n    align-self: flex-start;\n}\n\n#trimble-common-footer .footer-content .footer-bottom>div:nth-child(2) {\n    width: 650px;\n}\n\n#tekla-common-footer .footer-bottom .trimble-logo,\n#trimble-common-footer .footer-bottom .trimble-logo {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 19.8px;\n}\n\n#tekla-common-footer .footer-bottom .trimble-logo svg,\n#trimble-common-footer .footer-bottom .trimble-logo svg {\n    max-width: 150px;\n}\n\n#tekla-common-footer .footer-bottom .footer-description,\n#trimble-common-footer .footer-bottom .footer-description {\n    display: flex;\n    flex-direction: column;\n    align-self: stretch;\n    gap: 1rem;\n}\n\n#tekla-common-footer .footer-bottom .footer-description p,\n#trimble-common-footer .footer-bottom .footer-description p {\n    max-width: 500px;\n}\n\n#tekla-common-footer .footer-description p,\n#tekla-common-footer .footer-description a,\n#trimble-common-footer .footer-description p,\n#trimble-common-footer .footer-description a {\n    font-size: 14px;\n    line-height: 28px;\n    letter-spacing: 0.035px;\n}\n\n#tekla-common-footer .footer-description a,\n#trimble-common-footer .footer-description a {\n    font-weight: 600;\n}\n\n#tekla-common-footer .links,\n#trimble-common-footer .links {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n}\n\n#trimble-common-footer .links {\n    gap: 1rem;\n}\n\n#tekla-common-footer .links a,\n#trimble-common-footer .links a {\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 20px;\n    letter-spacing: 0.0025em;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n}\n\n#tekla-common-footer .links button.cookie-preferences-link,\n#trimble-common-footer .links button.cookie-preferences-link {\n    font-size: 12px;\n    text-decoration: underline;\n    font-weight: 600 !important;\n}\n\n#tekla-common-footer .w-20,\n#trimble-common-footer .w-20 {\n    width: 20% !important;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 24px;\n}\n\n#tekla-common-footer .footer-bottom .w-20,\n#trimble-common-footer .footer-bottom .w-20 {\n    gap: 12px;\n}\n\n#tekla-common-footer .w-60,\n#trimble-common-footer .w-60 {\n    width: 60% !important;\n}\n\n/* RESPONSIVITY */\n\n@media only screen and (max-width: 1340px) {\n\n    #tekla-common-footer .footer-base .footer-top .footer-content,\n    #tekla-common-footer .footer-base .footer-bottom .footer-content,\n    #trimble-common-footer>.footer-base .footer-content {\n        max-width: 1160px;\n    }\n}\n\n/* Large devices (laptops/desktops, up to 1200px) */\n@media only screen and (max-width: 1200px) {\n\n    #tekla-common-footer .footer-base .footer-content,\n    #trimble-common-footer>.footer-base .footer-content {\n        max-width: 100%;\n        gap: 5%;\n        padding: 3.75rem 2rem;\n    }\n\n    #tekla-common-footer .footer-content>div:first-child,\n    #trimble-common-footer .footer-content .footer-bottom>div:first-child {\n        width: 20%;\n    }\n\n    #tekla-common-footer .footer-content>div:nth-child(2),\n    #trimble-common-footer .footer-content .footer-bottom>div:nth-child(2) {\n        width: 50%;\n    }\n\n    #tekla-common-footer .footer-content>div:last-child,\n    #trimble-common-footer .footer-content .footer-bottom>div:last-child {\n        width: 20%;\n    }\n}\n\n/* Small devices (portrait tablets and large phones, 768px and down) */\n@media only screen and (max-width: 768px) {\n\n    #tekla-common-footer .footer-content>div:last-child,\n    #trimble-common-footer .footer-content .footer-bottom>div:last-child {\n        width: 15%;\n    }\n\n    #tekla-common-footer .footer-top .footer-content>.social-icons {\n        justify-content: center;\n        width: 10%;\n    }\n}\n\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n\n    #tekla-common-footer .footer-base .footer-content,\n    #trimble-common-footer .footer-base .footer-bottom {\n        flex-direction: column;\n        gap: 40px;\n        flex-wrap: wrap;\n    }\n\n    #tekla-common-footer .footer-base .footer-content {\n        padding: 40px 20px;\n    }\n\n    #trimble-common-footer .footer-base .footer-bottom {\n        padding: 3rem 0 0 0;\n    }\n\n    #tekla-common-footer .footer-base .footer-content>div,\n    #trimble-common-footer .footer-base .footer-content .footer-bottom>div {\n        width: 100% !important;\n    }\n\n    #tekla-common-footer .footer-top .links-with-titles {\n        gap: 40px;\n        flex-wrap: wrap;\n    }\n\n    #tekla-common-footer .footer-top .footer-content>.social-icons {\n        justify-content: flex-start;\n    }\n\n    #tekla-common-footer .footer-top .links-with-titles div {\n        width: 40%;\n    }\n\n    #tekla-common-footer .footer-bottom .links {\n        gap: 32px;\n    }\n\n    #trimble-common-footer .footer-bottom .links {\n        gap: 1.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
